export default "__VITE_ASSET__DKBKcxuN__"